export const FUNNELS_REPORT_ID = 'funnels';
